export default {
    messages: {
        list: [],
        isSending: false
    }
}
